module.exports = __webpack_public_path__ + "static/media/logo_white.4f97b7a2.svg";